<div class="mobile-nav-menu d-flex position-absolute flex-column d-lg-none">
  <!-- NAV BAR -->
  <div class="mobile-nav-bar d-flex justify-content-between bg-primary">
    <a [routerLink]="['/']" routerLinkActive="router-link-active">
      <label id="homeLink" class="accessibility-only">Go To Home Page</label>
      <img alt="" class="home-logo p-1" src="assets/images/logos/LogoWhite.png" draggable="false" />
    </a>
    <!--Notifications-->
    <div class="nav-item">
      <fgb-notification-button></fgb-notification-button>
    </div>
    <button
      attr.aria-label="{{ 'nav.toggle.screenreader' | translate }}"
      class="nav-item fw-bold navbar-toggler text-white m-0 px-2"
      (click)="isCollapsed = !isCollapsed"
    >
      <span class="icon material-icons material-mobile-nav">menu</span>
    </button>
  </div>

  <!-- NAV SCREEN -->
  <div [ngbCollapse]="isCollapsed" class="mobile-nav-menu-dropdown bg-primary">
    <div class="mobile-nav-container-box">
      <div *ngIf="memberDetails$ | async as member">
        <div class="member-card text-white">
          <!-- Close Button -->
          <button
            class="close-button position-absolute border-0"
            attr.aria-label="{{ 'modal.close' | translate }}"
            (click)="isCollapsed = !isCollapsed"
          >
            <i class="material-icons close-btn text-white">close</i>
          </button>

          <a [routerLink]="['/']">
            <img alt="" class="nav-home-logo" src="assets/images/logos/LogoWhite.png" draggable="false" />
          </a>
          <div class="account-details">
            <div class="account-info">
              <div class="font-size-14 text-uppercase font-page-heading fw-bold">
                {{ member.FirstName + ' ' + member.Surname }}
              </div>
              <div class="d-flex font-size-12" *ngIf="memberCard$ | async as card">
                <div>{{ card.ProductCode | accountMembership | translate }}</div>
                <div class="px-1">-</div>
                <div>{{ card.MemberId }}</div>
              </div>
            </div>
            <div class="language-container ms-auto">
              <fgbcl-language-button-select
                [hiddenLanguagesByLcid]="['4105', '1033', '1032', '1037', '3084', '1036']"
                [version]="2"
              />
            </div>
          </div>
        </div>
      </div>

      <button
        class="d-flex align-items-center justify-content-center btn bg-black text-white font-heading my-3 w-100 font-size-14"
        [routerLink]="['/rewards/wallet']"
      >
        <span class="material-icons me-2 font-size-20 text-center walleticon">qr_code_2 </span>
        {{ 'nav.wallet' | translate }}
      </button>

      <!-- Nav Buttons -->
      <div class="mobile-nav-button-container">
        <a
          class="nav-item fw-bold large-item"
          [routerLink]="['/']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <div class="nav-item-title-div">
            <div class="nav-text fw-bold">{{ 'nav.home' | translate }}</div>
          </div>
          <div><span class="icon material-icons mx-0" aria-hidden="true">chevron_right</span></div>
        </a>
        <a
          class="nav-item fw-bold large-item"
          [routerLink]="['/account']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <div class="nav-item-title-div">
            <div class="nav-text fw-bold">{{ 'nav.account' | translate }}</div>
          </div>
          <div><span class="icon material-icons mx-0" aria-hidden="true">chevron_right</span></div>
        </a>

        <a
          class="nav-item"
          [routerLink]="['/rewards/wallet']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <div class="nav-item-title-div">
            <div class="nav-text fw-bold">{{ 'nav.wallet' | translate }}</div>
          </div>
          <div><span class="icon material-icons mx-0" aria-hidden="true">chevron_right</span></div>
        </a>
        <a class="nav-item" [routerLink]="['/rewards']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
          <div class="nav-item-title-div">
            <div class="nav-text fw-bold">{{ 'nav.rewards' | translate }}</div>
          </div>
          <div><span class="icon material-icons mx-0" aria-hidden="true">chevron_right</span></div>
        </a>
        <a
          class="nav-item"
          [routerLink]="['/challenges']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <div class="nav-item-title-div">
            <div class="nav-text fw-bold">{{ 'nav.challenges' | translate }}</div>
          </div>
          <div><span class="icon material-icons mx-0" aria-hidden="true">chevron_right</span></div>
        </a>

        <a class="nav-item" [routerLink]="['/games']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
          <div class="nav-item-title-div">
            <div class="nav-text fw-bold">{{ 'nav.games' | translate }}</div>
          </div>
          <div><span class="icon material-icons mx-0" aria-hidden="true">chevron_right</span></div>
        </a>

        <a
          class="nav-item"
          [routerLink]="['/benefits']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <div class="nav-item-title-div">
            <div class="nav-text fw-bold">{{ 'nav.benefits' | translate }}</div>
          </div>
          <div><span class="icon material-icons mx-0" aria-hidden="true">chevron_right</span></div>
        </a>
        <ng-container *fgbWebsiteContentFeatureFlag="'feature.flag.offers'">
          <a
            class="nav-item"
            [routerLink]="['/offers']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <div class="nav-item-title-div">
              <div class="nav-text fw-bold">{{ 'nav.offers' | translate }}</div>
            </div>
            <div><span class="icon material-icons mx-0" aria-hidden="true">chevron_right</span></div>
          </a>
        </ng-container>
        <ng-container *fgbWebsiteContentFeatureFlag="'feature.flag.newsletters'">
          <a
            class="nav-item"
            [routerLink]="['/newsletters']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <div class="nav-item-title-div">
              <div class="nav-text fw-bold">{{ 'nav.newsletter' | translate }}</div>
            </div>
            <div><span class="icon material-icons mx-0" aria-hidden="true">chevron_right</span></div>
          </a>
        </ng-container>

        <a class="nav-item" [routerLink]="['/gallery']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
          <div class="nav-item-title-div">
            <div class="nav-text fw-bold">{{ 'nav.gallery' | translate }}</div>
          </div>
          <div><span class="icon material-icons mx-0" aria-hidden="true">chevron_right</span></div>
        </a>

        <a class="nav-item" [routerLink]="['/faq']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
          <div class="nav-item-title-div">
            <div class="nav-text fw-bold">{{ 'nav.faq' | translate }}</div>
          </div>
          <div><span class="icon material-icons mx-0" aria-hidden="true">chevron_right</span></div>
        </a>
        <a class="nav-item" [routerLink]="['/contact']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
          <div class="nav-item-title-div">
            <div class="nav-text fw-bold">{{ 'nav.contact.us' | translate }}</div>
          </div>
          <div><span class="icon material-icons mx-0" aria-hidden="true">chevron_right</span></div>
        </a>

        <a class="nav-item" [routerLink]="['/terms']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
          <div class="nav-item-title-div">
            <div class="nav-text fw-bold">{{ 'nav.terms' | translate }}</div>
          </div>
          <div><span class="icon material-icons mx-0" aria-hidden="true">chevron_right</span></div>
        </a>

        <a class="nav-item logout-link-div" (click)="logout()">
          <div class="nav-text fw-bold">{{ 'nav.log.out' | translate }}</div>
        </a>
      </div>
    </div>
  </div>
</div>
